import { IconButton, InfoIcon, Modal } from "@carbon6/c6-frontend-design";
import { useState } from "react";
import { HatModalHeader } from "@/components/modal";
import styles from "./WorkerQueueGuide.module.css";

const guides = {
  upload: [
    {
      title: "파일 전송과 반입",
      description:
        "파일 전송 대기(pending_upload) 상태에서는 Worker가 작업을 가져갈 수 없습니다. 파일 전송이 끝나 반입 대기(uploaded)가 되면 Worker가 처리합니다.",
    },
    {
      title: "멈춘/취소된 업로드",
      description:
        "처리 중인 Worker가 없는 업로드와 취소·삭제한 업로드는 Storage의 멈춘/취소된 업로드에서 확인합니다.",
    },
  ],
  diagnostic: [
    {
      title: "중단과 재시작",
      description:
        "중단·재시작은 Worker가 요청을 반영할 때까지 기다릴 수 있습니다. 반영을 기다리는 동안 상태에 요청 중으로 표시됩니다.",
    },
    {
      title: "진행 보존",
      description:
        "재시작은 진행을 초기화하고 처음부터 실행합니다. 이어서 실행은 기존 진행을 보존합니다. 작업 상세에서 요청할 수 있습니다.",
    },
  ],
};

export function WorkerQueueGuide({ kind }: { kind: "upload" | "diagnostic" }) {
  const [open, setOpen] = useState(false);
  const title = kind === "upload" ? "업로드 큐 안내" : "진단 큐 안내";
  const sections = [
    ...guides[kind],
    {
      title: "목록 정렬",
      description:
        "요청 시각이 오래된 순서로 표시합니다. 조회 기간과 겹치는 작업, 미완료 작업, 종료 시각 미기록 작업을 포함합니다. 확대와 이동은 조회 기간을 바꾸지 않습니다.",
    },
  ];
  return (
    <>
      <IconButton text={title} size="sm" variant="surface" onClick={() => setOpen(true)}>
        <InfoIcon />
      </IconButton>
      <Modal open={open} onClose={() => setOpen(false)} size="lg">
        <HatModalHeader title={title} close />
        <Modal.Body padding={false}>
          <div className={styles.content}>
            {sections.map((section) => (
              <section key={section.title} className={styles.section}>
                <h3 className={styles.title}>{section.title}</h3>
                <p className={styles.note}>{section.description}</p>
              </section>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
